import React from 'react';
import { StyledDiv, StyledH1 } from './styles'
import PropTypes from 'prop-types'

const FormSection = (props) => {
    return (
        <StyledDiv>
            <StyledH1>{props.heading}</StyledH1>
            {props.children}
        </StyledDiv>
    )
}
FormSection.propTypes = {
    heading: PropTypes.string
}
export default FormSection


// WEBPACK FOOTER //
// ./src/components/FormSection/index.js